<!--
 * @Descripttion: 查看明细-项目费用/修改 => 个人&个体&供应商子集
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <BaseButton
      v-if="detailInfo.needBack === 1"
      link
      :icon="ArrowLeft"
      @click="onBack"
    >
      返回
    </BaseButton>
    <xrk-table
      style="height: 650px"
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
    <div
      v-if="+detailInfo.isEdit === 1"
      style="margin: 0 auto; width: 80px; height: 80px; padding-bottom: 20px"
    >
      <BaseButton style="width: 80px" @click="onRemove">移除</BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ArrowLeft } from '@element-plus/icons-vue';
import {
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  useTableColumn,
  BaseButton,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';

import { orderDetail, removePerson } from '../data-source/apis';
import {
  indexCol,
  individualNameCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  payStatusCol,
  parkNameCol
} from '../fields/columns';
import {
  individualNameSearch,
  fullNameSearch,
  phoneSearch,
  payStatusSearch,
  parkNameSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';

const route = useRoute();
const router = useRouter();
const detailInfo = computed(() => {
  return {
    aspOrderId: +route.query.aspOrderId,
    projectStructureType: +route.query.projectStructureType, //是否是个体
    isEdit: +route.query.isEdit || 0, //是否是修改 1是 0否
    needBack: +route.query.needBack || 0, //是否需要返回按钮
    aspSupplierOrderId: +route.query.aspSupplierOrderId || '', //Asp支付给P的订单ID
    hidePayStatus: +route.query.hidePayStatus || 0 //是否隐藏支付状态 1是 0否(从供应商查看明细进入)
  };
});

const onBack = () => {
  // Asp支付给P的订单 移除后列表为空则上一个供应商也会没数据 产品让直接跳回到订单管理页
  if (detailInfo.value.aspSupplierOrderId && !pageData.value.length) {
    router.replace({
      name: 'asp-order'
    });
    return;
  }
  router.go(-1);
};
const xrkTableRef = ref<XrkTableRef>();

const isGeti = computed(() => {
  return detailInfo.value.projectStructureType === 2;
});

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchBtn: {
      show: true,
      text: '搜索'
    },
    resetBtn: {
      show: true,
      text: '重置'
    },
    searchColumns: [
      isGeti.value && individualNameSearch,
      isGeti.value && parkNameSearch,
      { ...fullNameSearch, label: isGeti.value ? '经营者' : '终端服务人员' },
      phoneSearch,
      detailInfo.value.hidePayStatus !== 1 && {
        ...payStatusSearch,
        config: {
          options: ORDER_PAY_STATUS_PAY_SUCCESS
        }
      }
    ].filter(Boolean),
    otherComponents: []
  };
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      detailInfo.value.isEdit === 1 &&
        useTableColumn({
          type: '_selection',
          prop: 'id',
          align: 'center',
          fixed: 'left',
          width: 120,
          selectionDisabled(row) {
            return [1, 2].includes(+row.payStatus);
          }
        }),
      indexCol,
      isGeti.value && individualNameCol,
      isGeti.value && parkNameCol,
      { ...fullNameCol, label: isGeti.value ? '经营者' : '终端服务人员' },
      phoneCol,
      settlementTaskCountCol,
      taskPriceCol,
      projectPayPriceCol,
      detailInfo.value.hidePayStatus !== 1 && {
        ...payStatusCol,
        formatter({ cellValue }) {
          return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
        }
      }
    ].filter(Boolean)
  };
});

const pageData = ref([]);
const getListAjax = async params => {
  const reqData = {
    ...params,
    aspOrderId: detailInfo.value.aspOrderId,
    projectStructureType: detailInfo.value.projectStructureType,
    aspSupplierOrderId: detailInfo.value.aspSupplierOrderId
  };
  const data = await orderDetail(reqData);
  pageData.value = data.data.list;
  return data;
};

const onRefreshTabel = () => {
  xrkTableRef.value.initCurrentList();
};

const onRemove = async () => {
  const selectionVal = xrkTableRef.value.getSelectionRows();
  if (!selectionVal.length) {
    XrkMessage.warning('请选择要操作的数据');
    return;
  }
  await XrkMessageBox.confirm(
    '移除后，将不能重新加入到当前订单内，请谨慎操作。对应的平台服务费和商务服务费订单金额会同步更新。',
    '确认',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    }
  );
  await removePerson({
    ids: selectionVal.map(item => item.id),
    projectStructureType: detailInfo.value.projectStructureType,
    aspOrderId: detailInfo.value.aspOrderId
  });
  xrkTableRef.value.clearSelectionRows();
  onRefreshTabel();
};
</script>
<style lang="scss"></style>
